import { lazy } from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';
import AuthRoute from './AuthRoute';
import { USER_ROLE } from '@/shared/constants';

import MainLayout from '@/shared/components/layout/MainLayout';
import PageWrapper from './PageWrapper';

import { PATH } from '@/shared/constants';

const StaffQrPage = lazy(() => import('@/pages/staff/qr/Page'));

export const staffRoutes: RouteObject = {
  path: PATH.STAFF_SHARED.INDEX,
  element: <AuthRoute allowedRoles={[USER_ROLE.ADMIN, USER_ROLE.STAFF, USER_ROLE.INSTRUCTOR]} />,
  children: [
    {
      element: <MainLayout />,
      children: [
        { index: true, element: <Navigate to={PATH.STAFF_SHARED.QR} replace /> },
        {
          path: 'qr/:lessonSessionId',
          element: (
            <PageWrapper>
              <StaffQrPage />
            </PageWrapper>
          ),
        },
      ],
    },
  ],
};
